// Customer information types
export interface CustomerInfo {
    shippingAddress: Partial<ShippingAddress>
    billingAddress: Partial<Address>
    differentShippingAddress?: boolean
    newsletter?: boolean
    pfasRestrictedProduct?: boolean
}

export interface Address {
    newsletter?: boolean
    firstName: string
    lastName: string
    address1: string
    address2?: string
    apartmentHouseNumber?: string
    phoneNumber: string
    zipCode: string
    email: string
    city: string
    country: string
    state?: string
}

export interface ShippingAddress {
    firstName: string
    lastName: string
    email: string
    address1: string
    apartmentHouseNumber?: string
    phoneNumber?: string
    address2?: string
    zipCode: string
    country: string
    city: string
    state?: string
}

export enum QuantityChangeAction {
    increase = "increase",
    decrease = "decrease",
    delete = "delete"
}

// Payment params types
export interface PaymentParams {
    paymentMethod: string
    paymentReturnPage: string
    paymentFailedPage: string
    termsAndConditions: boolean
    address: any
    shippingAddress: any
}

export type MarketLayout = "na" | "eu"

// Popup modal types
export interface ErrorResponse {
    unavailable: UnavailableItem[]
}

export interface UnavailableItem {
    unavailable: number
    product: {
        name: string
        variantName: string
        price: string
    }
}

export type ModalState =
    | { type: "closed" }
    | {
          type: "some_items_unavailable"
          items: UnavailableItem[]
          totalRemainingItemsInBasket: number
      }
    | { type: "cart_empty" }

export interface OutOfStockItem {
    item: string
    product: any | unknown
    originalQuantity: number
    unavailable: number
    available: number
}
